<template>
  <v-main>
    <head>
      <title>Create a new shop - Foraje</title>
      <meta name="description" content="A form to allow you to create a new shop, to tell all your customers what you have for sale.">
    </head>
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
      >
        <v-col cols="12" md="6" class="mx-auto">
          <v-card class="fill-height">
            <form @submit.prevent="CreateNewShop">
              <v-card-title style="justify-content: center">
                Create a New Shop
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="newshop.name"
                  label="Name"
                  counter="200"
                  hint="What is your shop called?"
                  required
                >
                </v-text-field>
                <v-text-field
                  v-model="newshop.address"
                  label="Address"
                  hint="Where is your shop located? Postal address preferable if possible (makes it easier for people to find you)"
                  counter="300"
                  required
                >

                </v-text-field>
                <v-textarea
                  v-model="newshop.description"
                  label="Description"
                  hint="A brief description of your shop"
                  counter="2000"
                  >
<!--                  TODO make these counters enforce length-->

                </v-textarea>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
              <v-btn color="primary" type="submit" :loading="shop_create_loading" >
                Create
                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
              </v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ShopCreate',
  data: () => ({
    shop_create_loading: false,
    slug_lookup_loading: false,
    newshop: {
      name: '',
      shopslug: '',
      address: '',
      description: '',
    },
    drawer: null,
    address_response_loading: false,
    disablebuttons: true,
  }),
  computed: {
  },
  props: {
  },

  mounted() {
  },
  methods: {
    // TODO Should we allow users to add products to pending shops?
    CreateNewShop() {
      const authheader = `Token ${this.$store.getters.token}`;
      this.shop_create_loading = true;
      axios.post('forms/products/shops/create/', this.newshop, {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.shop_create_loading = false;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Shop Created! Once it\'s approved it will appear in other user\'s searches',
            alert_model: true,
          });
        })
        .then(() => {
          this.$router.push('/user/shops/');
        });
    },
    CheckIfSlugExists() {
      this.slug_lookup_loading = true;
      const slug = this.slugified_name();
      axios.get(`shops/${slug}/`);
    },
  },
};
</script>

<style scoped>

</style>
